<template>
  <div class="feedback">
    <div class="title-default">
      <i class="goback" @click="$router.go(-1)">意见反馈</i> /
      <span>问题详情</span>
    </div>
    <div class="question">
      <div class="title">
        问题
        <span :class="{ good: feedbackData.status }">{{
          feedbackData.status == 0 ? "待处理" : "已处理"
        }}</span>
      </div>
      <div class="time">
        提交时间：{{ feedbackData.createTime }}
        <span>编号：{{ feedbackData.id }}</span>
      </div>
      <div class="content">
        {{ feedbackData.content }}
      </div>
      <div class="imgs">
        <el-image
          v-for="(item, index) in feedbackData.images"
          class="img"
          :key="index"
          :src="item"
          :preview-src-list="questionList"
        ></el-image>
      </div>
    </div>

    <div class="question reply" v-if="feedbackData.solveTime">
      <div class="title">
        客服回复
      </div>
      <div class="time">回复时间：{{ feedbackData.solveTime }}</div>
      <div class="content">
        {{ feedbackData.solveContent }}
      </div>
      <!-- <div class="imgs">
        <el-image
          v-for="item in 8"
          class="img"
          src="http://10.5.192.161:8086/img/home_pic_4.1b9d29c9.png"
          :preview-src-list="replyList"
        ></el-image>
      </div> -->
      <div class="logo">
        <img src="~@/assets/img/jushifulogo_blue.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      feedbackData: {
        images: []
      },
      questionList: [],
      replyList: []
    };
  },
  mounted() {
    this.getFeedbackDetail();
  },
  methods: {
    getFeedbackDetail() {
      this.$fetch(`/user/api/feedback/detail?id=${this.$route.query.id}`).then(
        res => {
          if (res.code == 0) {
            console.log(res);
            this.feedbackData = res.data;
            this.questionList = res.data.images;
          } else {
            this.$message(res.message);
          }
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.feedback {
  .title-default {
    background: #fff;
  }
  .question {
    background: #fff;
    margin-top: 15px;
    padding-bottom: 20px;
    &.reply {
      margin-top: 15px;
    }
    .title {
      background: #f9fafa;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 46px;
      font-weight: bold;
      font-size: 16px;
      color: #000;
      span {
        color: #2f3133;
        font-weight: normal;
        font-size: 14px;
        &.good {
          color: #46ae32;
        }
      }
    }
    .time {
      height: 56px;
      padding: 0 20px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #5e6066;
    }
    .content {
      color: #2f3133;
      padding: 0 20px;
      text-align: justify;
      font-size: 14px;
      line-height: 26px;
    }
    .imgs {
      padding: 0 20px;
      margin-top: 12px;
      display: flex;
      .img {
        margin-right: 8px;
        width: 100px;
        height: 100px;
        &:last-child {
          margin-right: 0;
        }
      }
      // &/deep/img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .logo {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      padding-right: 20px;
      img {
        width: 127px;
        height: 33px;
      }
    }
  }
}
</style>
